import React from 'react';
import { graphql } from 'gatsby';
import HeaderMain from '../components/HeaderMain';
import Footer from '../components/Footer';
import HeroSingle from '../components/pages/HeroSingle';
import SEO from '../components/seo';
import '../styles/app.scss';

const fieldtrips = ({ data }) => {
    const { wordpressPage: post } = data;
    console.log(post);
    const test_title = post.yoast_title;
    const new_test_title = test_title.replace('&#039;', "'");
    const inlineCss = {
        maxWidth: '600px',
        marginTop: '50px',
    };
    return (
        <>
            <SEO
                title={new_test_title}
                meta={post.yoast_meta}
                description={
                    post.yoast_json_ld[0].wordpress__graph[0].description
                }
            />
            <HeaderMain />
            <HeroSingle pageTitle={post.title} />

            <section className="page-section smallestwdt centersec">
                <div className="container">
                    <div
                        dangerouslySetInnerHTML={{
                            __html: post.content,
                        }}
                    />
                </div>
            </section>
            <section className="whywelist page-section bg-primary text-white">
                <div className="container smallestwdt" style={{ maxWidth: '600px' }}>
                    <h2 className="yellowtxt">WHO WE WELCOME</h2>
                  {/*  <p style={{ marginTop: '30px' }}>With local university recreational options shifting this July, we are here to make your child's transition seamless, positive, and stress-free. At We Rock The Spectrum Piscataway, <strong>we never charge a registration fee!</strong> 🎁 <strong>Limited-Time Transfer Bonus:</strong> Buy a 6-week session today, and get <strong>1 bonus drop-in class completely free</strong> to keep their summer momentum going!</p> */}
                    <ul className="startxt starlistspacing" style={{ marginTop: '30px', textAlign: 'left' }}>
                        <li className="whitetxt" style={{ textTransform: 'none', fontFamily: 'gothambook' }}>Public and private schools</li>
                        <li className="whitetxt" style={{ textTransform: 'none', fontFamily: 'gothambook' }}>Special education classrooms</li>
                        <li className="whitetxt" style={{ textTransform: 'none', fontFamily: 'gothambook' }}>Self-contained classrooms</li>
                        <li className="whitetxt" style={{ textTransform: 'none', fontFamily: 'gothambook' }}>Preschool and Pre-K programs</li>
                        <li className="whitetxt" style={{ textTransform: 'none', fontFamily: 'gothambook' }}>Autism programs</li>
                        <li className="whitetxt" style={{ textTransform: 'none', fontFamily: 'gothambook' }}>ABA centers</li>
                        <li className="whitetxt" style={{ textTransform: 'none', fontFamily: 'gothambook' }}>ESY programs</li>
                        <li className="whitetxt" style={{ textTransform: 'none', fontFamily: 'gothambook' }}>Camps</li>
                        <li className="whitetxt" style={{ textTransform: 'none', fontFamily: 'gothambook' }}>Homeschool groups</li>
                        <li className="whitetxt" style={{ textTransform: 'none', fontFamily: 'gothambook' }}>Community organizations</li>
                    </ul>
                </div>
            </section>
            <section className="whywelist page-section bg-secondary text-white">
                <div className="container smallestwdt">
                    <h2 className="yellowtxt">FIELD TRIP OPTIONS</h2>
                 {/*   <p><strong>$160 per 6-Week Session</strong> (1 Class Per Week)</p> */}
                    <div className="schedule-table-wrap">
                        <table className="schedule-table">
                            <thead>
                                <tr>
                                    <th>Shared Sensory Field Trip</th>
                              {/*      <th>Thursday Evenings</th> */}
                                    <th>Private Sensory Field Trip</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td data-label="Shared Sensory Field Trip">
                                        • 2 hours<br />
                                        • $18 per child<br />
                                        • 8-child minimum<br />
                                        • Up to 15 children<br />
                                        • The sensory gym remains open to other guests during the visit.<br />
                                        • Great for smaller classrooms and groups looking for an affordable field trip experience.<br />
                                    </td>
                              {/*      <td data-label="Thursday Evenings"></td> */}
                                    <td data-label="Private Sensory Field Trip">
                                        • 2 hours<br />
                                        • $300 for up to 10 children<br />
                                        • $20 for each additional child<br />
                                        • Up to 30 children<br />
                                        • Includes private access to the sensory gym for your group.<br />
                                        • Great for larger groups and programs that would benefit from exclusive use of the facility.<br />
                                        • Teachers, paraprofessionals, required 1:1 aides, and necessary support staff are included at no additional charge.<br />
                                        • Additional 30 minutes: $50<br />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </section>
            <section className="page-section smallestwdt respitesec padding-less-under">
                <div className="container">
                    <h2 className="bluetxt" style={{ marginBottom: '60px', textAlign: 'center' }}>WHAT’S INCLUDED</h2>
                    <div className="openplft">
                        <img
                            src="https://werockthespectrumpiscataway.wrtsfranchise.com/wp-content/uploads/2026/10/Child-on-Rock-Wall.webp"
                            alt="Child on rock wall"
                        />
                    </div>
                    <div className="openprgt withmarbtm">
                        <ul className="startxt starlistspacing">
                            <li className="greentxt"><span className="bluetxt">Access to our sensory gym and specialized equipment</span></li>
                            <li className="greentxt"><span className="bluetxt">Gross-motor and sensory play opportunities</span></li>
                            <li className="greentxt"><span className="bluetxt">Social and imaginative play</span></li>
                            <li className="greentxt"><span className="bluetxt">Inclusive environment for children of all abilities</span></li>
                            <li className="greentxt"><span className="bluetxt">Space for required teachers, aides, and support staff</span></li>
                            <li className="greentxt"><span className="bluetxt">Staff available to help orient groups to the facility</span></li>
                        </ul>
                    </div>
                </div>
            </section>
            <section className="whywelist page-section bg-primary text-white">
                <div className="container smallestwdt" style={{ maxWidth: '800px' }}>
                    <h2 className="yellowtxt">SCHOOL DISTRICT PURCHASE ORDERS</h2>
                    <p style={{ marginTop: '30px' }}>We Rock the Spectrum – Piscataway works with schools and organizations to make the field trip booking process as simple as possible.<br /><br />School district purchase orders may be accepted for approved bookings. Please contact us for vendor documentation, quotes, invoices, or other information required by your district.</p> 
                    <img
                            src="https://werockthespectrumpiscataway.wrtsfranchise.com/wp-content/uploads/2026/10/Child-on-Zipline.webp"
                            alt="Child on zipline"
                        />
                </div>
            </section>
            <section className="whywelist page-section bg-secondary text-white" id="contformsec">
                <div className="container smallestwdt">
                    <h2 className="yellowtxt">READY TO PLAN YOUR VISIT?</h2>
                    <p>Tell us about your group and we’ll help you determine the best field trip option.</p>
                    <div className="container flexwrap contactform_wrap">
                        <iframe style={{ minHeight: '890px' }}
                            src="https://werockthespectrumpiscataway.wrtsfranchise.com/field-trips/"
                            title="contactform"
                        />
                    </div>
                </div>
            </section>
            
            <Footer />
        </>
    );
};

export default fieldtrips;

export const pageQuery = graphql`
    query($id: String!) {
        wordpressPage(id: { eq: $id }) {
            id
            title
            slug
            content            
            yoast_meta {
                name
                property
            }
            yoast_title
            yoast_json_ld {
                wordpress__graph {
                    description
                }
            }
        }
    }
`;
